module.exports = "/_next/static/images/property-mobile-2a0d4764356ec16b8f71a29a1a70631a.png";